import axios from 'axios';
import { API_CONFIG } from '../config/env';
import { unwrapApiString } from '../utils/apiResponse';

class ApiKeysService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  /** GET returns masked API key name (e.g. EYt3*****) — envelope: { data: { name } } */
  async getApiKey(): Promise<string> {
    const response = await axios.get(`${API_CONFIG.BASE_URL}/api-keys`, {
      headers: this.getAuthHeaders(),
    });
    const key = unwrapApiString(response.data);
    if (!key) {
      throw new Error('Unexpected API key response format');
    }
    return key;
  }

  /** POST returns full API key — envelope: { data: { token } } */
  async generateApiKey(): Promise<string> {
    const response = await axios.post(`${API_CONFIG.BASE_URL}/api-keys`, {}, {
      headers: this.getAuthHeaders(),
    });
    const key = unwrapApiString(response.data);
    if (!key) {
      throw new Error('API key was not returned by the server');
    }
    return key;
  }

  async deleteApiKey(): Promise<void> {
    await axios.delete(`${API_CONFIG.BASE_URL}/api-keys`, {
      headers: this.getAuthHeaders(),
    });
  }
}

export const apiKeysService = new ApiKeysService();
